/* eslint-disable max-len */
import threeEssentialsBgActive from '../../../assets/images/three_essentials_bg_active.svg';
import {
    MenuConfigProps, NavigationUrls
} from './product-switcher.types';

export const menuConfig: MenuConfigProps = [
    {
        id: 'threeEssentials',
        icons: ['threeEssentials'],
        styles: { _active: { backgroundImage: threeEssentialsBgActive } },
        navigationUrlId: NavigationUrls.threeEssentials
    },
    {
        id: 'reading',
        icons: ['readingEggs', 'readingEggspress', 'fastPhonics'],
        styles: {
            borderColor: '#CF3D90',
            backgroundImage: 'none',
            _hover: { background: 'rgba(207, 61, 144, 0.05)' },
            _active: { background: 'linear-gradient(0deg, #FDE7F3 0%, #FDE7F3 100%), var(--colour-white, #FFF)' }
        },
        navigationUrlId: NavigationUrls.reading
    },
    {
        id: 'writing',
        icons: ['writingLegends'],
        styles: {
            borderColor: '#ADC938',
            backgroundImage: 'none',
            _hover: { background: 'rgba(173, 201, 56, 0.05)' },
            _active: { background: 'linear-gradient(0deg, #F7FFD7 0%, #F7FFD7 100%), #FFF' }
        },
        navigationUrlId: NavigationUrls.writing
    },
    {
        id: 'mathematics',
        icons: ['mathSeeds', 'prime'],
        styles: {
            borderColor: '#39ACE3',
            backgroundImage: 'none',
            _hover: { background: 'rgba(57, 172, 227, 0.05)' },
            _active: { background: '#DBF3FF' }
        },
        navigationUrlId: NavigationUrls.mathematics
    }
];
